import {ReactNode} from 'react';
import {ReviewCard} from './review-card';

interface PreviewParticipantsCardProps {
  cycleName: string;
  includedTags: string[];
  excludedTags: string[];
  onEdit?: () => void;
  cardVariant?: 'default' | 'detail';
}

export const PreviewParticipantsCard = ({
  cycleName,
  includedTags,
  excludedTags,
  onEdit,
  cardVariant,
}: PreviewParticipantsCardProps) => {
  return (
    <ReviewCard title="Basics" onEdit={onEdit} variant={cardVariant}>
      <div className="flex flex-col gap-4">
        <ReviewField label="Name">
          <p className="text-sm font-semibold leading-[22px] text-blackTwo">
            {cycleName || '—'}
          </p>
        </ReviewField>
        <ReviewField label="Recipients" divided>
          <Pills labels={includedTags} emptyLabel="No recipients selected." />
        </ReviewField>
        <ReviewField label="Excluded" divided>
          <Pills labels={excludedTags} emptyLabel="No exclusions." excluded />
        </ReviewField>
      </div>
    </ReviewCard>
  );
};

const ReviewField = ({
  label,
  children,
  divided = false,
}: {
  label: string;
  children: ReactNode;
  divided?: boolean;
}) => (
  <div
    className={`flex flex-col gap-2 ${
      divided ? 'border-t border-borderLight pt-4' : ''
    }`}>
    <span className="text-sm font-medium leading-[22px] text-textBody">
      {label}
    </span>
    {children}
  </div>
);

const Pills = ({
  labels,
  emptyLabel,
  excluded = false,
}: {
  labels: string[];
  emptyLabel: string;
  excluded?: boolean;
}) =>
  labels.length ? (
    <div className="flex flex-wrap gap-2">
      {labels.map((label, index) => (
        <span
          key={`${label}-${index}`}
          className={`rounded-lg border border-textBody bg-white px-3.5 py-2 text-xs font-medium leading-5 text-blackTwo ${
            excluded ? 'line-through' : ''
          }`}>
          {label}
        </span>
      ))}
    </div>
  ) : (
    <span className="text-sm leading-[22px] text-textBody">{emptyLabel}</span>
  );
